<template>
  <div class="avecor-table" style="background:#eee !important"> 
    <v-row justify-center class="px-2 pt-2" no-gutters v-if="companies[companyId]">
        <v-col cols="6">
            <v-row no-gutters>
              <v-col :cols="2" class="pr-2">
                <!-- @change="v => changeSalespersonForCompany(companyId,v)" -->
                <v-autocomplete
                  label="Myyjä"
                  :value="companies[companyId].salesperson"
                  :items="getSalespersons"
                  @change="v => $store.dispatch('changeSalespersonForCompany', {companyId:companyId,newSalesperson:v})"
                  persistent-hint
                  item-text="text"
                  item-value="id"
                  filled
                />
              </v-col>
              <!-- <v-col md="1" cols="3" class="pr-2">
                <v-text-field
                  label="Avecor id"
                  placeholder=" "
                  :value="companyId"
                  disabled
                  filled
                ></v-text-field>
              </v-col> -->
              <v-col :cols="user.uid === 'p2VRFkTz4JUzqkGoTPUt4CWQAxa2' ? 1 : 2" class="pr-2" v-if="user.uid === 'p2VRFkTz4JUzqkGoTPUt4CWQAxa2'">
                <v-text-field
                  label="Test Netvisor avain"
                  placeholder=" "
                  
                  :value="companies[companyId].netvisorKey_test_env"
                  @change="inlineSaveCompanyDetails($event,'netvisorKey_test_env')"
                  filled
                ></v-text-field>
              </v-col>
              <v-col :cols="user.uid === 'p2VRFkTz4JUzqkGoTPUt4CWQAxa2' ? 1 : 2" class="pr-2" >
                <v-text-field
                  label="Netvisor avain"
                  :disabled="true"
                  placeholder=" "
                  :value="companies[companyId].netvisorKey"
                  @change="inlineSaveCompanyDetails($event,'netvisorKey')"
                  filled
                ></v-text-field>
              </v-col>
              
              <v-col :cols="4" class="pr-2">
                <v-text-field
                  label="Yrityksen nimi"
                  placeholder=" "
                  :value="companies[companyId].companyName"
                  @change="inlineSaveCompanyDetails($event,'companyName')"
                  filled
                ></v-text-field>
              </v-col>
              <v-col :cols="2" class="pr-2">
                <v-text-field
                  label="Y-tunnus"
                  placeholder=" "
                  :value="companies[companyId].companyId"
                  @change="inlineSaveCompanyDetails($event,'companyId')"
                  filled
                ></v-text-field>
              </v-col>
              <v-col :cols="2" class="pr-2">
                <v-autocomplete
                  :value="companies[companyId].industry"
                  :items="Object.entries(settings.industries).map(i => {return i[1] } )"
                  @change="inlineSaveCompanyDetails($event,'industry')"
                  filled
                  label="Toimiala"
                  item-text="fi"
                  item-value="id"
                />
              </v-col>
              <v-col md="3" cols="3" class="pr-2">
                <v-text-field
                  label="Osoite"
                  placeholder=" "
                  :value="companies[companyId].deliveryAddress"
                  @change="inlineSaveCompanyDetails($event,'deliveryAddress')"
                  filled
                ></v-text-field>
              </v-col>
              <v-col md="3" cols="2" class="pr-2">
                  <v-text-field
                  label="Postikoodi"
                  placeholder=" "
                  :value="companies[companyId].deliveryPostalCode"
                  @change="inlineSaveCompanyDetails($event,'deliveryPostalCode')"
                  filled
                ></v-text-field>
              </v-col>
              <v-col md="3" cols="2" class="pr-2">
                  <v-text-field
                  label="Kaupunki"
                  placeholder=" "
                  :value="companies[companyId].deliveryCity"
                  @change="inlineSaveCompanyDetails($event,'deliveryCity')"
                  filled
                ></v-text-field>
              </v-col>
              <v-col md="3" cols="2" class="pr-2">
                  <v-text-field
                  label="Maa"
                  placeholder=" "
                  :value="companies[companyId].deliveryCountry"
                  @change="inlineSaveCompanyDetails($event,'deliveryCountry')"
                  filled
                ></v-text-field>
              </v-col>
              <!-- <v-col md="3" cols="3" class="pr-2" >
                <v-text-field
                  label="Vedosten sähköposti"
                  placeholder=""
                  :value="companies[companyId].clientPrintDetailsEmail"
                  @change="inlineSaveCompanyDetails($event,'clientPrintDetailsEmail')"
                  filled
                ></v-text-field>
              </v-col> -->
            </v-row>
            <v-row class="mx-0 mt-0" no-gutters>
              <v-col md="2" cols="3" class="pr-2">
                <v-autocomplete
                  label="Laskutusformaatti"
                  :value="companies[companyId].billingFormat"
                  :items="getBillingFormats"
                  item-text="fi"
                  item-value="id"
                  @change="inlineSaveCompanyDetails($event,'billingFormat')"
                  filled
                />
              </v-col>
              <v-col md="1" cols="3" class="pr-2" v-if="companies[companyId].billingFormat === 'email' ">
                <v-checkbox 
                  style="margin-top:0px;"
                  label="Eri laskutus sposti?"
                  v-model="companies[companyId].differentBillingEmail" 
                  @change="inlineSaveCompanyDetails($event,'differentBillingEmail')"
                  class="avecor-table-checkbox hide-field-details"
                  color="blue"
                />
              </v-col>
              <v-col md="1" cols="3" class="pr-1" v-if="companies[companyId].billingFormat === 'paper'">
                <v-checkbox 
                  style="margin-top:0px;margin-right:50px;"
                  label="Eri laskutus- osoite?"
                  v-model="companies[companyId].differentBillingAddress" 
                  @change="inlineSaveCompanyDetails($event,'differentBillingAddress')"
                  class="avecor-table-checkbox hide-field-details"
                  color="blue">
                </v-checkbox>
              </v-col>
              <v-col md="3" cols="3" class="pr-2">
                <v-text-field
                  label="Laskutussähköposti"
                  placeholder=" "
                  :value="companies[companyId].billingEmail"
                  @change="inlineSaveCompanyDetails($event,'billingEmail')"
                  filled
                ></v-text-field>
              </v-col>
              <v-col md="3" cols="3" class="pr-2" v-if="companies[companyId].billingFormat === 'eInvoice'">
                <v-text-field
                  label="Verkkolaskutusosoite"
                  placeholder=" "
                  :value="companies[companyId].eBillingAddress"
                  @change="inlineSaveCompanyDetails($event,'eBillingAddress')"
                  filled
                ></v-text-field>
              </v-col>
              <v-col md="2" cols="3" class="pr-2" v-if="companies[companyId].billingFormat === 'eInvoice'">
                <v-autocomplete
                  :value="companies[companyId].eBillingOperator"
                  :items="settings.eBillingOperators"
                  @change="inlineSaveCompanyDetails($event,'eBillingOperator')"
                  filled
                  label="Operaattori"
                  item-text="name"
                  item-value="id"
                />
                <!-- <v-text-field
                  label="Operaattori"
                  placeholder=" "
                  :value="companies[companyId].eBillingOperator"
                  @change="inlineSaveCompanyDetails($event,'eBillingOperator')"
                  filled
                ></v-text-field> -->
              </v-col>
              <v-col md="3" cols="3" class="pr-2" v-if="companies[companyId].billingFormat === 'paper' && companies[companyId].differentBillingAddress">
                <v-text-field
                  label="Laskutusosoite"
                  placeholder=" "
                  :value="companies[companyId].billingAddress"
                  @change="inlineSaveCompanyDetails($event,'billingAddress')"
                  filled
                ></v-text-field>
              </v-col>
              <v-col md="2" cols="3" class="pr-2" v-if="companies[companyId].billingFormat === 'paper' && companies[companyId].differentBillingAddress">
                <v-text-field
                  label="Lask. postikoodi"
                  placeholder=" "
                  :value="companies[companyId].billingPostalCode"
                  @change="inlineSaveCompanyDetails($event,'billingPostalCode')"
                  filled
                ></v-text-field>
              </v-col>
              <v-col md="2" cols="3" class="pr-2" v-if="companies[companyId].billingFormat === 'paper' && companies[companyId].differentBillingAddress">
                <v-text-field
                  label="Laskutus kaupunki"
                  placeholder=" "
                  :value="companies[companyId].billingCity"
                  @change="inlineSaveCompanyDetails($event,'billingCity')"
                  filled
                ></v-text-field>
              </v-col>
              <v-col md="2" cols="3" class="pr-2" v-if="companies[companyId].billingFormat === 'paper' && companies[companyId].differentBillingAddress">
                <v-text-field
                  label="Laskutus maa"
                  placeholder="Finland"
                  :value="companies[companyId].billingCountry"
                  @change="inlineSaveCompanyDetails($event,'billingCountry')"
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="2" class="pr-2 text-right">
                <v-checkbox 
                  label="Varastoasiakas"
                  v-model="companies[companyId].customerProductsWarehoused" 
                  @change="inlineSaveCompanyDetails($event,'customerProductsWarehoused')"
                  class="avecor-table-checkbox avecor-select hide-field-details"
                  style="margin-top:0px;"
                  color="blue">
                </v-checkbox>
              </v-col>
              <v-col cols="2" class="pr-2 text-right">
                <v-checkbox 
                  label="Tunnettu toimija"
                  v-model="companies[companyId].knownOperator" 
                  @change="inlineSaveCompanyDetails($event,'knownOperator')"
                  class="avecor-table-checkbox avecor-select hide-field-details"
                  style="margin-top:0px;"
                  color="blue">
                </v-checkbox>
              </v-col>
              <v-col cols="2" class="pr-2 text-right">
                <v-checkbox 
                  label="Webshop"
                  v-model="companies[companyId].isShop" 
                  @change="inlineSaveCompanyDetails($event,'isShop')"
                  class="avecor-table-checkbox avecor-select hide-field-details"
                  style="margin-top:0px;"
                  color="blue">
                </v-checkbox>
              </v-col>
              <v-col cols="2" class="pl-1 pr-1">
                <v-text-field
                  label="Shopify tag"
                  placeholder=" "
                  :value="companies[companyId].shopifyCustomerIdTag"
                  @change="inlineSaveCompanyDetails($event,'shopifyCustomerIdTag')"
                  filled
                ></v-text-field>
              </v-col>
              
            </v-row>
            <!-- <v-row no-gutters>
              <v-col cols="2" class="pr-2 text-right">
                <v-checkbox 
                  label="Varastoasiakas"
                  v-model="companies[companyId].customerProductsWarehoused" 
                  @change="inlineSaveCompanyDetails($event,'customerProductsWarehoused')"
                  class="avecor-table-checkbox avecor-select hide-field-details"
                  style="margin-top:0px;">
                </v-checkbox>
              </v-col>
              <v-col cols="2" class="pl-1 pr-1">
                <v-text-field
                  label="Shopify tag"
                  placeholder=" "
                  :value="companies[companyId].shopifyCustomerIdTag"
                  @change="inlineSaveCompanyDetails($event,'shopifyCustomerIdTag')"
                  filled
                ></v-text-field>
              </v-col>
              <v-col md="1" cols="3" class="pr-2" v-if="device === 'desktop'">
                <v-checkbox 
                  label="Jaetut vedokset"
                  v-model="companies[companyId].sharedDrafts" 
                  @change="inlineSaveCompanyDetails($event,'sharedDrafts')"
                  class="avecor-table-checkbox avecor-select hide-field-details"
                  style="margin-top:0px;">
                </v-checkbox>
              </v-col>
              <v-col md="1" cols="3" class="pr-2" v-if="device === 'desktop'">
                <v-checkbox 
                  label="Jaetut logot"
                  v-model="companies[companyId].sharedLogos" 
                  @change="inlineSaveCompanyDetails($event,'sharedLogos')"
                  class="avecor-table-checkbox avecor-select hide-field-details"
                  style="margin-top:0px;">
                </v-checkbox>
              </v-col>
            </v-row> -->
        </v-col>
        <v-col cols="6">
          <v-textarea
            label="Kommentit yrityksestä"
            :value="companies[companyId].companyComments"
            @change="inlineSaveCompanyDetails($event,'companyComments')"
            rows=11
            :auto-grow="false"
            filled
          ></v-textarea>
        </v-col>
    </v-row>
    <!-- <v-row class="mx-2 mt-0" no-gutters>
      <v-col md="12" cols="12" class="pr-2" >
        <v-textarea
          label="Kommentit yrityksestä"
          :value="companies[companyId].companyComments"
          @change="inlineSaveCompanyDetails($event,'companyComments')"
          rows=2
          :auto-grow="true"
          filled
        ></v-textarea>
      </v-col>
    </v-row> -->
  </div>
</template>

<script>
import { mapFields,mapMultiRowFields } from 'vuex-map-fields'
import dateFormat from 'dateformat'
import shared from './../../shared'
import axios from 'axios'

export default {
    props: ['companyId'],
    data: () => ({
    }),
    mounted() {
    },
    computed: {
      getBillingFormats(){
        var billingFormats = this.settings.billingFormats
        return Object.keys(this.settings.billingFormats).reduce(function(result, key) {
          result.push({...billingFormats[key]});
          return result;
        }, []);
      },
      ...mapFields([
        "device",
        "user",
        "company.companies",
        "contact.contacts",
        "order.orders",
        "staff.staff",
        "settings",
      ]),
      getSalespersons(){
        var staff = this.staff
        var salespersons = []
        Object.keys(this.staff).map(function(key, index) {
          var s = staff[key]
          if(s.role === 'sales' || s.role === 'ceo' || s.id ==='RqjgIwdXWzXqCR2MOVr1etp2iY22') salespersons.push({text:s.firstName, id:s.id})
          return {...s}
        })
        return salespersons
      },
    },
    watch: {},
    created () {
      this.syncCompanyToNetvisor = shared.syncCompanyToNetvisor
    },

    methods: {
      /* async changeSalespersonForCompany(companyId,newSalesperson){
        try{
          if (confirm('Haluatko varmasti siirtää yrityksen ja sen tilaukset toiselle myyjälle?')) {
            this.$store.dispatch('showSnack', { snack:true, snackTimeout:0, snackText:"Yritystä ja sille kohdennetut tilaukset siirretään.", snackButtonText: "", errorType:"", snackColor:'deep-blue',right:false,top:false})
            console.log({companyId,newSalesperson})
            var url = this.settings.dev ? 'http://0.0.0.0:5000/avecor-709ff/us-central1/updateSalespersonForCompanyId' : 'https://us-central1-avecor-709ff.cloudfunctions.net/updateSalespersonForCompanyId'
            let res = await axios.post(
              url,
              //`http://0.0.0.0:5000/avecor-709ff/us-central1/translate`,
              { companyId, newSalesperson},
            )
            this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
          }
        }
        catch(e){
          console.log(e)
        }
      }, */
      async inlineSaveCompanyDetails(event, field){
        var companyId = this.companyId
        if(field === "differentBillingAddress" || field === "differentBillingEmail")  {
          if(!event) event = false
        }
        this.$store.dispatch('company/set', {
          id:companyId,
          [field]:event,
        }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
        var env = this.settings.env
        if((env === 'production' && this.companies[companyId].netvisorKey) || (env === 'development' && this.companies[companyId].netvisorKey_test_env)){
          if(companyId && (field === 'salesperson' || field === 'companyName' || field === 'companyId' || 
            field === 'deliveryAddress' || field === 'deliveryPostalCode' || field === 'deliveryCity' ||
            field === 'eBillingOperator' ||  field === 'eBillingAddress' ||  field === 'billingFormat' ||
            field === 'billingEmail' || field === 'billingAddress' || field === 'billingPostalCode' || field === 'billingCity')){
            
            await this.$store.dispatch('syncCompanyToNetvisor', {companyId,env})
            //this.syncCompanyToNetvisor(companyId,env)
          }  
        }
        
      },
      customFormatter(date) {
        return dateFormat(date, "yyyy-mm-dd")
      },
      deleteItem (item) {
        this.$store.dispatch('contact/delete', item.id)
          .then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/blocks/CompanyInfo.vue